// extracted by mini-css-extract-plugin
export default {"input":"SearchIngredientsBar_input__3C0e6"};